export default __webpack_public_path__ + "static/media/18-min.c71de607.jpg";